(() => {
  const replaceImage = (sectionSelector, url, alt, highPriority = false) => {
    if (!url) return;

    const section = document.querySelector(sectionSelector);
    const image = section?.querySelector('.media-block img');
    if (!section || !image || image.dataset.lurxecareV31 === 'true') return;

    const picture = image.closest('picture');
    picture?.querySelectorAll('source').forEach((source) => {
      source.removeAttribute('srcset');
      source.removeAttribute('sizes');
    });

    image.src = url;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.alt = alt;
    image.decoding = 'async';
    image.dataset.lurxecareV31 = 'true';

    if (highPriority) {
      image.loading = 'eager';
      image.fetchPriority = 'high';
    } else {
      image.loading = 'lazy';
    }
  };

  const addReturnStory = () => {
    const showcase =
      document.querySelector("[id$='__section_UpjyCL']") ??
      document.querySelector('.color-custom-section_UpjyCL')?.closest('.shopify-section');
    const groups = showcase?.querySelectorAll('.group-block');
    const target = groups?.[1];

    if (!target || target.querySelector('[data-lurxecare-return-story]')) return;

    const story = document.createElement('div');
    const collectionsUrl = document.body.dataset.lurxecareCollectionsUrl || '/collections';
    story.className = 'lurxecare-return-story';
    story.dataset.lurxecareReturnStory = 'true';
    story.innerHTML = `
      <span class="lurxecare-return-story__eyebrow">More to look forward to</span>
      <h2>Make self-care your favorite ritual.</h2>
      <p>Explore body and face-care finds, beauty tools and our current Cleansing Ritual Set—curated to make everyday care feel intentional.</p>
      <a href="${collectionsUrl}">Explore every ritual <span aria-hidden="true">→</span></a>
    `;
    target.append(story);
  };

  const initialize = () => {
    const { lurxecareOilImage } = document.body.dataset;

    replaceImage(
      "[id$='__individual_product_card_theme_install'], .color-custom-individual_product_card_theme_install",
      lurxecareOilImage,
      'Woman applying body oil during a warm self-care ritual'
    );
    addReturnStory();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
